import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useVersionCheck } from "@/hooks/useVersionCheck";

async function reloadWithFreshCache() {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {
    // ignore
  }
  window.location.reload();
}

export function UpdateAvailableToast() {
  const updateAvailable = useVersionCheck();
  const shownRef = useRef(false);

  useEffect(() => {
    if (!updateAvailable || shownRef.current) return;
    shownRef.current = true;

    toast("Nova versão disponível", {
      description: "Atualize para ver as últimas melhorias.",
      duration: Infinity,
      action: {
        label: "Atualizar agora",
        onClick: () => {
          void reloadWithFreshCache();
        },
      },
    });
  }, [updateAvailable]);

  return null;
}
